<template>
  <a-button class="ml-1 mr-1" :type="primary" :size="size" :ghost="ghost" :icon="icon" @click="generateFile()"><slot></slot></a-button>
</template>

<script>

import ntkoBrowser from '@/views/ntko/ntkobackground.js'

export default {
  name: 'Writer',
  props: {
    clerkTemplateKey: {
      type: String,
      required: true
    },

    icon: {
      type: String,
      default: 'file-text'
    },
    urlValue: {
      type: String,
      default: '',
    },
    primary: {
      type: String,
      default: 'primary'
    },

    ghost:{
      type:Boolean,
      default:false
    },
    size:{
      type:String,
      default:'default'
    }
  },
  methods: {
    generateFile () {
      if (this.urlValue){
        let that = this
        this.$http.get(this.urlValue).then(function (res) {
          if(res.hasData === false) {
            that.$message.info(res.msg)
          }else {
            that.doGenerateFile()
          }
        });
      }else {
        this.doGenerateFile()
      }
    },
    doGenerateFile() {
      const that = this
      var ntkoed = ntkoBrowser.ExtensionInstalled()
      if (ntkoed) {
        let userId =  that.$ls.get('user').id;
        ntkoBrowser.openWindow(process.env.VUE_APP_WEB_SERVER + '/#/ntkoViewNormal?clerkTemplateKey=' + that.clerkTemplateKey, process.env.VUE_APP_ProductCaption, process.env.VUE_APP_NtkoBrowserProductKey)
      } else {
        alert('未安装 ntko')
        var iTop = ntkoBrowser.NtkoiTop() // 获得窗口的垂直位置
        var iLeft = ntkoBrowser.NtkoiLeft() // 获得窗口的水平位置
        window.open(process.env.VUE_APP_WEB_SERVER + '/3/ntko/exeindex.html', '', 'height=200px,width=500px,top=' + iTop + 'px,left=' + iLeft + 'px,titlebar=no,toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no')
      }
    }
  }
}
</script>

<style scoped>

</style>
